import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

export default function AdminProtectedRoute({ children, requireSuperAdmin, requireShowLeads }) {
  const { isAuthenticated, admin } = useAdminAuth();

  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;

  if (requireSuperAdmin && !admin?.is_superadmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requireShowLeads && !admin?.show_leads) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
}
